var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('b-icon',{style:({ color: _vm.successColor}),attrs:{"icon":"check-circle-fill","font-scale":0.9}}):_c('b-icon',{style:({ color: _vm.frownColor}),attrs:{"icon":"x-circle-fill","font-scale":0.9}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }